module.exports = __webpack_public_path__ + "img/couples-032.78d0831a.jpg";